export const environment = { 
    production: false,
    host:"mmr2nmjkw3.execute-api.us-east-1.amazonaws.com",
    segurity:"https://",
    version:"/v1/",
    typeService:"rest/onboarding/",
    envName: 'DEV',
    encryptionSecret: "AAAAAAAAAAAAAAAA",
    xApiKey:"5VjmIazerUb1VvMQLjTG3v7wDvms0xG86TZXpeq8",
    Authorization: "123",
    
    awsRegion:"us-east-1",
    apiKey: 'v1.public.eyJqdGkiOiIxNDAyNGQyNC1kMTg3LTQxMmYtOGRiZS05ZDQ4ZTM5MDZlZDIifVkhKqabvp1sUrJBM5Oj2gXXeOqDG-yDHQFioQ9vop51NwLAteEfI31VsB_d2ve99M0U1B3fzkQv-R9OGyVOEwZTBP8BU9LE2-_Eya6vyPLdkfH3gS3pdUPGz5Y8cJ3ZvHZDrSbJERR88ta7HH02gIkkNLkRp_r3SozRH71k7JqExKGPg4yZG_Uwz_bokh8Z-1cjCe9E2yD4u9D5ruqqcdV_WWFggQpS4k4BxefNeb_aQk_OyYovGLyrvKmhy55YU2NJ30snNtY9hhqS7W4NmzMQCXQ61YPrH0wbF_oDsMfGOvRCpU_DmuepooYpqXqfEasNtCmpwC3rqk7hD9TDtG8.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx', 
    placeIndexName:"mnt-onboarding-dev-delivery-maps-places",
    mapName:"mnt-onboarding-dev-delivery-maps",

    appVersion: '1.0.1',
};
